import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

function InsightButtons({ insights, onClick }) {
  return (
    <Button.Group basic vertical style={{ border: "none" }}>
      {insights.map((i) => {
        return (
          <Button
            key={i.name}
            style={{ textAlign: "left" }}
            content={i.name}
            onClick={(e) => {
              e.preventDefault();
              onClick(i);
            }}
          />
        );
      })}
    </Button.Group>
  );
}

InsightButtons.propTypes = {
  insights: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  onClick: PropTypes.func.isRequired,
};

InsightButtons.defaultProps = {
  insights: [],
};
export default InsightButtons;
